import { render, staticRenderFns } from "./LdTable.vue?vue&type=template&id=21d10bd0&"
import script from "./LdTable.vue?vue&type=script&lang=js&"
export * from "./LdTable.vue?vue&type=script&lang=js&"
import style0 from "./LdTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports